var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.278 8.82l-.003-2.339a4.333 4.333 0 10-4.333 4.335l2.338.002.005 4.12 2-.002-.005-4.116 4.117.004.002-2-4.121-.004zm.999-.999l3.123.003a1 1 0 01.999 1.001l-.002 2a1 1 0 01-1 1l-3.116-.004.004 3.114a1 1 0 01-.999 1.001l-2 .002a1 1 0 01-1-.998l-.005-3.123-1.34-.001a5.333 5.333 0 115.334-5.336l.002 1.341zM5.942 4.15a2.333 2.333 0 012.333 2.334l.003 2.335-2.335-.002a2.334 2.334 0 11-.001-4.667zm.041 1.04a1.334 1.334 0 10.001 2.67h1.335l-.001-1.335c0-.737-.598-1.334-1.335-1.334z",
    id: "volunteer_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    opacity: 0.9,
    transform: "rotate(45 8.03 8.607)",
    xlinkHref: "#volunteer_svg__a",
    fillRule: "evenodd"
  }));
}
export default SvgVolunteer;